import {combineReducers} from 'redux'
import types from 'actions/types'
import Immutable from 'seamless-immutable'
import {isNil, uniqBy} from 'lodash'
import {JobBoardStatus} from 'helpers/production'

export const data = (state = Immutable([]), action) => {
  switch (action.type) {
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_ATTEMPT:
      return state

    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_SUCCESS:
      return action.page > 0
        ? [...state, ...action.data]
        : action.data

    case types.PRODUCTION_ADD_JOB_CARD_SUCCESS:
      return state.filter(order => order.id !== action.data.result.orderId)

    case types.PRODUCTION_ADD_JOB_CARDS_SUCCESS:
      // 1. Merge in updated orders into the list
      const updatedOrders = action.data.result.map(jobCard => jobCard.order)
      const orders = state.map(order => {
        const updatedOrder = updatedOrders.find(updatedOrder => updatedOrder.id === order.id)
        return isNil(updatedOrder) ? order : updatedOrder
      })

      const orderIds = action.data.result
        .filter(jobCard => jobCard.order.productionScheduled)
        .map(jobCard => jobCard.orderId)

      // 2. Remove orders that are now production scheduled
      return orders.filter(order => !orderIds.includes(order.id))

    case types.QUOTING_QUOTE_UPDATE_ORDER:
      return state.map(order => {
        return order.id === action.order.id
            ? action.order
            : order
      })
          .filter(order => !order.productionScheduled)
          .filter(order => order.jobStatus !== JobBoardStatus.noProductionRequired)

    case types.PRODUCTION_FILTER_JOB_CARDS_FOR_DATE_RANGE:
      return action.data

    case types.PRODUCTION_SET_CONFIRMED_JOBS:
      return action.confirmedJobs

    case types.PRODUCTION_REMOVE_ORDER_FROM_JOB_BOARD_SUCCESS:
      return state.filter(order => order.id !== action.data)

    default:
      return state
  }
}

export const count = (state = Immutable(0), action) => {
  switch (action.type) {
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_SUCCESS:
      return action.count

    case types.PRODUCTION_UPDATE_CONFIRMED_ORDER_COUNT:
        return action.count

    case types.PRODUCTION_ADD_JOB_CARD_SUCCESS:
      return state - 1

    case types.PRODUCTION_ADD_JOB_CARDS_SUCCESS:
      return state - uniqBy(action.data.result.map(jobCard => jobCard.order), 'id')
                      .filter(order => order.productionScheduled)
                      .length

    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_COUNT_SUCCESS:
      return action.count

    case types.PRODUCTION_REMOVE_ORDER_FROM_JOB_BOARD_SUCCESS:
      return state - 1

    default:
      return state
  }
}

export const page = (state = Immutable(0), action) => {
  switch (action.type) {
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_ATTEMPT:
      return action.page || 0
    default:
      return state
  }
}

export const loading = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_ATTEMPT:
      return true
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_SUCCESS:
      return false
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_FAILURE:
      return false
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_COUNT_ATTEMPT:
      return true
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_COUNT_SUCCESS:
      return false
    case types.PRODUCTION_LOAD_CONFIRMED_JOBS_COUNT_FAILURE:
      return false
    default:
      return state
  }
}

export default combineReducers({
  data,
  count,
  page,
  loading,
})
